export default __webpack_public_path__ + "static/media/AKM_1.c66dfe48.png";